import m from "../../geodata/es2015/worldHigh";
window.am4geodata_worldHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/worldHigh.js
// module id = null
// module chunks = 